import { apiGet, apiPost, apiPut, apiDelete } from '../lib/api-client';
import type { LessonNote, LessonBookmark } from '@edytech/shared/types';

export interface NoteInput {
  lessonId: number;
  content: string;
}

export interface BookmarkInput {
  lessonId: number;
  note?: string | null;
  positionSec: number;
}

export const studyService = {
  // ============================ Notes ============================
  async getNotes(): Promise<LessonNote[]> {
    return apiGet<LessonNote[]>('/notes');
  },

  async getLessonNotes(lessonId: number): Promise<LessonNote[]> {
    return apiGet<LessonNote[]>(`/notes/lesson/${lessonId}`);
  },

  async createNote(input: NoteInput): Promise<LessonNote> {
    return apiPost<LessonNote>('/notes', input);
  },

  async updateNote(id: number, input: { content: string }): Promise<LessonNote> {
    return apiPut<LessonNote>(`/notes/${id}`, input);
  },

  async deleteNote(id: number): Promise<{ id: number }> {
    return apiDelete<{ id: number }>(`/notes/${id}`);
  },

  // ============================ Bookmarks ============================
  async getBookmarks(lessonId?: number): Promise<LessonBookmark[]> {
    return lessonId
      ? apiGet<LessonBookmark[]>('/bookmarks', { lessonId })
      : apiGet<LessonBookmark[]>('/bookmarks');
  },

  async createBookmark(input: BookmarkInput): Promise<LessonBookmark> {
    return apiPost<LessonBookmark>('/bookmarks', input);
  },

  async deleteBookmark(id: number): Promise<{ id: number }> {
    return apiDelete<{ id: number }>(`/bookmarks/${id}`);
  },
};
